var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Titulo',{attrs:{"titulo":'Informes - ' + _vm.routeName}})],1),_c('div',{staticClass:"margin-informes"},[_c('h4',{staticClass:"color-secundary"},[_vm._v("\n      Base operaciones\n    ")]),_c('br'),_c('Qlik')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }